export default {"src":"/_next/static/media/drop.6f1c48ef.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};